export const APP_GOVERNANCE_APPROVAL_TYPE = 'CONNECTED_APP';
export const APP_GOVERNANCE_APPROVAL_ACTION = 'INSTALL';